import type { SubscriptionEstimate } from "features/subscriptions/types";

import {
  getWhitelabelCustomization,
  trackMetaPixel,
} from "common/helpers/utils";
import type { PricingPeriodInfo } from "common/types";

export function trackSubscriptionEvent(
  type: "purchase" | "subscribe",
  subscriptionId: string,
  value: number,
  quantity: number,
) {
  const eventData = {
    value,
    currency: "USD",
    content_type: "subscription",
    content_ids: [subscriptionId],
    num_items: quantity,
  };

  if (type === "purchase") {
    trackMetaPixel("track", "Purchase", eventData);
  } else {
    trackMetaPixel("track", "Subscribe", eventData);
  }
}

export function formatPrice(price: number) {
  return price.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    trailingZeroDisplay: "stripIfInteger",
  });
}

export function formatPricingPeriodInfo(pricingPeriodInfo: PricingPeriodInfo) {
  const { period, period_unit } = pricingPeriodInfo;

  if (period === 1) {
    return period_unit;
  }
  return `${period} ${period_unit}s`;
}

export function parseEstimate(estimate: SubscriptionEstimate) {
  const invoiceEstimate =
    estimate.invoice_estimate || estimate.next_invoice_estimate;

  const flatFeeItem = invoiceEstimate.line_items.find(
    ({ pricing_model }: { pricing_model: string }) =>
      pricing_model === "flat_fee",
  );
  const perUnitLineItem = invoiceEstimate.line_items.find(
    ({ pricing_model }: { pricing_model: string }) =>
      pricing_model === "per_unit",
  );

  return {
    amountDue: invoiceEstimate.amount_due / 100,
    nextBillingAt: estimate.subscription_estimate.next_billing_at,
    pricePerItem: perUnitLineItem ? perUnitLineItem.unit_amount / 100 : 0,
    //when there is no change, the flat fee item is not returned by chargebee, maybe we shouldn't call the request at all
    basePrice: flatFeeItem ? flatFeeItem.unit_amount / 100 : 0,
  };
}

export function getBaseWorkspaceUrl(workspaceId: string, to: string) {
  return getWhitelabelCustomization()
    ? `/${to}`
    : `/workspaces/${workspaceId}/${to}`;
}
